import { PAGINATION_RECORD_PER_PAGE } from "MainApp/features/App/constants";

export const POST_LIKED_USERS_PER_PAGE = PAGINATION_RECORD_PER_PAGE;